// Demo Firehose API Client
// No authentication required - public demo endpoints

import axios from "axios";
import { demoBaseURL, demoEndpoints, DemoSource } from ".";
import { NewsFeedItem } from "../firehose/models";

// Axios client for demo endpoints (no auth interceptors)
export const demoClient = axios.create({
  baseURL: demoBaseURL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Response types
export interface DemoSourcesResponse {
  sources: DemoSource[];
  delay_hours: number;
  description: string;
}

/**
 * Get demo news feed (24h delayed)
 * @param source Optional source filter
 */
export const getDemoNews = async (
  source?: DemoSource
): Promise<NewsFeedItem[]> => {
  const url = source
    ? `${demoEndpoints.news}?source=${source}`
    : demoEndpoints.news;
  const response = await demoClient.get(url);
  return response.data as NewsFeedItem[];
};

/**
 * Get demo news filtered by preset watchlist (Magnificent 7)
 */
export const getDemoWatchlistNews = async (): Promise<NewsFeedItem[]> => {
  const response = await demoClient.get(demoEndpoints.newsWithWatchlist);
  return response.data as NewsFeedItem[];
};

/**
 * Get available demo sources
 */
export const getDemoSources = async (): Promise<DemoSourcesResponse> => {
  const response = await demoClient.get(demoEndpoints.sources);
  return response.data as DemoSourcesResponse;
};
